import actions from '../../actionTypes';

export default payload => {
  return {
    type: actions.LOGOUT_ERROR,
    error: true,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/logoutError.js